import type { BankTransaction } from './bank-transaction.type.ts';
export interface BankTransactionExtension extends BankTransaction {}
export class BankTransactionExtension {
  get isUnmatched(): boolean {
    return this.state === 'UNMATCHED';
  }

  get isSystemProposed(): boolean {
    return this.state === 'SYSTEM_PROPOSED';
  }

  get isUserProposed(): boolean {
    return this.state === 'USER_PROPOSED';
  }

  get isMatched(): boolean {
    return this.state === 'MATCHED';
  }

  get isCredit(): boolean {
    return this.transactionType === 'CREDIT';
  }

  get isDebit(): boolean {
    return this.transactionType === 'DEBIT';
  }

  get formattedAmount(): string {
    const amount = this.amount / 100;
    const prefix = this.isCredit ? '+' : '-';
    return `${prefix}$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  get proposedMatch(): Record<string, unknown> | null {
    return (this.tioData?.proposed as Record<string, unknown>) || null;
  }
}

const Registration = {
  kind: 'object',
  name: 'bank-transaction',
  features: BankTransactionExtension,
};
export default Registration;
